import { Link } from "react-router-dom";
import Modal from "@/components/modal";
import CheckIcon from "@/assets/images/successfully-check.svg"
import Button from "@/components/buttons/Button";

interface IProps {
    isOpen: boolean;
    onClose: (value: boolean) => void;
}

export default function SuccessfulApplicationCard({ ...props }:IProps) {
    return (
        <Modal
            isOpen={props.isOpen}
            onClose={props.onClose}
            size="lg"
            className="bg-gradient-to-b shadow-none from-primary-300 w-[500px] h-[450px] to-white"
        >
            <div className="flex flex-col justify-between h-full">
                <div>
                    <div className="flex items-center justify-center mb-4">
                        <img src={CheckIcon} alt="Success Icon" />
                    </div>
                    <div className="max-w-[350px]  mx-auto">
                        <h2 className="text-2xl font-semibold text-[#041528] mb-2 text-center ">
                            Your Application Has Been Successfully Submitted!
                        </h2>
                    </div>
                    <div>
                        <p className="text-[#536067] mb-4 font-light text-center">
                            Thank you for submitting your application. To proceed,
                            please complete the payment using the reference number provided sent to you phone.
                        </p>
                    </div>
                </div>
                <div className="absolute bottom-5 left-[17%]   w-full">
                    <Link to={"/applications/investments"}>
                        <Button
                            intent="default"
                            type="button"
                            className="px-5 w-[65%] py-2.5 border-[#3C1E03] text-[#3C1E03] font-semibold">
                            Back to Applications
                        </Button>
                    </Link>
                </div>
            </div>
        </Modal>
    );
};

